import React, { useState, useEffect } from 'react';
import { Layout, Menu, Breadcrumb, Avatar, Dropdown, Badge, Tag, Space } from 'antd';
import {
  HomeOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  BankOutlined,
  ApartmentOutlined,
  HomeFilled,
  UserOutlined,
  BellOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ScanOutlined,
  PrinterOutlined,
  NotificationOutlined
} from '@ant-design/icons';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import request from '../utils/request';
import { getCurrentUser } from '../utils/user';
import './Layout.css';

const { Header, Sider, Content } = Layout;

const LayoutPage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const user = getCurrentUser();

  useEffect(() => {
    if (user.id) {
      fetchNotifications();
    }
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await request.get('/notification/list', {
        params: { user_id: user.id, page: 1, pageSize: 10 }
      });
      if (response.code === 200) {
        setNotifications(response.data.list || []);
      }
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuItems = [
    {
      key: '/dashboard',
      icon: <HomeOutlined />,
      label: '首页概览'
    },
    {
      key: '/property',
      icon: <EnvironmentOutlined />,
      label: '小区楼栋管理'
    },
    {
      key: '/user',
      icon: <TeamOutlined />,
      label: '用户管理'
    },
    {
      key: '/appointment',
      icon: <UserOutlined />,
      label: '预约管理'
    },
    {
      key: '/checkin',
      icon: <ScanOutlined />,
      label: '扫码核销'
    },
    {
      key: '/print',
      icon: <PrinterOutlined />,
      label: '打印模板'
    },
    {
      key: '/announcement',
      icon: <NotificationOutlined />,
      label: '公告广告'
    }
  ];

  const notificationItems = {
    items: notifications.length > 0 ? notifications.map(n => ({
      key: n.id,
      label: (
        <div className="notification-item">
          <div className="notification-title">{n.title}</div>
          <div className="notification-content">{n.content}</div>
          <div className="notification-time">
            {new Date(n.created_at).toLocaleString('zh-CN')}
          </div>
        </div>
      )
    })) : [{
      key: 'empty',
      label: '暂无新通知'
    }]
  };

  const userMenuItems = [
    {
      key: 'info',
      label: (
        <div className="user-info">
          <div className="user-name">{user.name}</div>
          <div className="user-role">
            <Tag color={user.isSuperAdmin ? 'red' : 'blue'}>
              {user.isSuperAdmin ? '系统超管' : '管理员'}
            </Tag>
          </div>
        </div>
      ),
      disabled: true
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  const getPageTitle = () => {
    const item = menuItems.find(m => m.key === location.pathname);
    return item?.label || '页面';
  };

  return (
    <Layout className="layout-container">
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        className="layout-sider"
        width={220}
        collapsedWidth={80}
      >
        <div className="logo">
          <BankOutlined style={{ fontSize: 24, color: '#fff' }} />
          {!collapsed && <span className="logo-text">物业管理系统</span>}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          className="menu"
        />
      </Sider>
      
      <Layout>
        <Header className="layout-header">
          <div className="header-left">
            <span className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </span>
            <Breadcrumb className="breadcrumb" items={[{ title: '首页' }, { title: getPageTitle() }]} />
          </div>
          
          <div className="header-right">
            <Dropdown menu={notificationItems} placement="bottomRight" trigger={['click']}>
              <Badge count={notifications.filter(n => !n.is_read).length} size="small">
                <BellOutlined className="header-icon" />
              </Badge>
            </Dropdown>
            
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
              <Space className="user-avatar">
                <Avatar style={{ backgroundColor: '#1890ff' }}>
                  {user.name?.charAt(0) || '管'}
                </Avatar>
                {!collapsed && (
                  <span className="user-name">{user.name}</span>
                )}
              </Space>
            </Dropdown>
          </div>
        </Header>
        
        <Content className="layout-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutPage;
